module.exports = __webpack_public_path__ + "assets/zjmp_icon1.96324a55.svg";